import { Injectable } from '@angular/core';
import { TagMaker } from '../core-services/TagMaker';
import { UserProfileSettingsService } from '../system-services';
import { TranslationService } from '../translations';

export enum CallToActionLocation {
    JobDashboard = 'jobDashboard',
    JobGuidance = 'jobGuidance'
}

export enum CTAActions {
    RelationshipGuide = 'relationshipGuide',
    CreateJob = 'createJob'
}

export type CallToActionConfig = {
    title: string;
    detailText: string;
    routerLink?: string;
    buttonTitle: string;
};

export type CallToActionConfigs = {
    [cta in CallToActionLocation]: CallToActionConfig[];
};

@Injectable({ providedIn: 'root' })
export class CallToActionService {
    ctaLocationConfigs: CallToActionConfigs;

    constructor(
        private readonly TM: TagMaker,
        private readonly TR: TranslationService,
        private readonly userProfile: UserProfileSettingsService
    ) {
        this.setLocationConfigs();
    }

    getConfigForLocation(location: CallToActionLocation): CallToActionConfig[] {
        return this.ctaLocationConfigs[location].filter(
            (config) => config.title
        );
    }

    hasConfig(location: CallToActionLocation): boolean {
        return this.getConfigForLocation(location).length > 0;
    }

    acknowledgeWelcomeGuideCta() {
        this.userProfile.hasAcknowledgedWelcomeGuideCta = true;
        this.userProfile.setUserProfileSetting();
        this.userProfile.userProfileSetting.hasAcknowledgedWelcomeGuideCta = true;
    }

    private setLocationConfigs() {
        this.ctaLocationConfigs = {
            jobDashboard: [
                {
                    title: this.TM.getCTALocationTitle(
                        CTAActions.RelationshipGuide,
                        CallToActionLocation.JobDashboard
                    ),
                    detailText: this.TM.getCTALocationDetail(
                        CTAActions.RelationshipGuide,
                        CallToActionLocation.JobDashboard
                    ),
                    routerLink: '/inspire/relationship',
                    buttonTitle: this.TR.key('relationshipGuide.title')
                }
            ],

            jobGuidance: [
                {
                    title: this.TM.getCTALocationTitle(
                        CTAActions.CreateJob,
                        CallToActionLocation.JobGuidance
                    ),
                    detailText: this.TM.getCTALocationDetail(
                        CTAActions.CreateJob,
                        CallToActionLocation.JobGuidance
                    ),
                    buttonTitle: this.TR.key('createJob.ctaButton')
                }
            ]
        };
    }
}
